import styled from "styled-components";
import { ITopBarProps } from "./TopBar";

export const _TopBarRoot = styled("div")<ITopBarProps & { $height?: number }>(
  ({ visible, bg, $height }) => {
    // const transitionValue = Math.max(46, $height || 46);
    return {
      height: "auto",
      background: bg,
      //marginTop: visible ? 0 : -transitionValue,
      //transition: "margin-top 0.8s ease",
      position: "relative",
      top: 0,
    };
  }
);
